import { CheckCircle2, MonitorDown } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { browserInstallHint, getInstallState, promptInstall, subscribeInstallState } from "../../lib/installApp";

export const InstallAppButton = ({ compact = false, testId = "install-app-button" }) => {
  const [state, setState] = useState(getInstallState);

  useEffect(() => subscribeInstallState(setState), []);

  if (state.standalone || state.installed) {
    return (
      <div className={`inline-flex items-center gap-2 rounded-2xl border border-emerald-200 bg-emerald-50 text-xs font-semibold text-emerald-800 ${compact ? "px-3 py-2" : "px-4 py-3"}`} data-testid={`${testId}-installed`}>
        <CheckCircle2 className="h-4 w-4" />
        {state.standalone ? "Running as installed app" : "Installed on this device"}
      </div>
    );
  }

  const handleClick = async () => {
    if (state.canPrompt) {
      const choice = await promptInstall();
      if (choice.outcome === "accepted") {
        toast.success("Lumen TMS is being installed — look for it on your desktop or Start menu.");
      }
      return;
    }
    toast.info(browserInstallHint(), { duration: 9000 });
  };

  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-2xl bg-zinc-900 font-semibold text-white transition hover:bg-zinc-800 ${compact ? "px-3 py-2 text-xs" : "px-4 py-3 text-sm"}`}
      data-testid={testId}
      onClick={handleClick}
      title="Install Lumen TMS as a desktop app"
      type="button"
    >
      <MonitorDown className="h-4 w-4" />
      Install Lumen TMS
    </button>
  );
};
